'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _emailList = require('./remote/emailList');

var EmailList = {
    fetchEmailLists: function fetchEmailLists(params) {
        return _emailList.EmailListRemote.fetchEmailLists(params);
    },
    postSubscribeToEmailList: function postSubscribeToEmailList(params) {
        return _emailList.EmailListRemote.postSubscribeToEmailList(params);
    },
    postUnsubscribeFromEmailList: function postUnsubscribeFromEmailList(params) {
        return _emailList.EmailListRemote.postUnsubscribeFromEmailList(params);
    }
};

exports.default = EmailList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/emailList.js
// module id = kA98
// module chunks = 46